import * as S from './styled'

import React, { useEffect, useRef, useState } from 'react'
import { EvaluationUser, TeamRole } from '@app/evaluation-core/types'

import Avatar from './Avatar'

interface UserAvatarPopoverProps {
  user: EvaluationUser
  isLastIndex: boolean
  zIndex: number
}

const roleLabel = (role: TeamRole) => {
  switch (role) {
    case TeamRole.SYSTEM_ADMIN:
      return 'Admin'
    case TeamRole.LEADER:
      return 'Team Leader'
    case TeamRole.EVALUATOR:
      return 'Evaluator'
    case TeamRole.READ_ONLY:
      return 'Read Only'
    default:
      return 'Unknown'
  }
}

const UserAvatarPopover: React.FC<UserAvatarPopoverProps> = ({
  user,
  isLastIndex,
  zIndex,
}) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  const email = user.view?.email ?? ''
  const displayName = email.split('@')[0] ?? email
  const hole = user.view?.hole != null ? user.view.hole + 1 : '—'

  return (
    <S.PopoverWrapper ref={ref} onClick={() => setOpen((v) => !v)}>
      <Avatar
        userColor={user.view?.color}
        isLastIndex={isLastIndex}
        zIndex={zIndex}
        userId={email}
      />
      {open && (
        <S.Popover>
          <S.PopoverHeader>
            <Avatar
              userColor={user.view?.color}
              isLastIndex
              zIndex={0}
              userId={email}
              size={40}
            />
            <div>
              <S.PopoverName>{displayName}</S.PopoverName>
              <div>
                <S.PopoverRoleBadge $role={user.role}>
                  {roleLabel(user.role)}
                </S.PopoverRoleBadge>
              </div>
            </div>
          </S.PopoverHeader>
          <S.PopoverDivider />
          <S.PopoverRow>
            <S.PopoverLabel>Email</S.PopoverLabel>
            {email}
          </S.PopoverRow>
          <S.PopoverRow>
            <S.PopoverLabel>Hole</S.PopoverLabel>
            {hole}
          </S.PopoverRow>
          <S.PopoverRow>
            <S.PopoverLabel>Color</S.PopoverLabel>
            <S.PopoverColorDot color={user.view?.color} />
            {user.view?.color}
          </S.PopoverRow>
        </S.Popover>
      )}
    </S.PopoverWrapper>
  )
}

export default UserAvatarPopover
